<template>
  <div
    class="full-image-banner critical-component-clear"
    :class="[
      liquid.layout === 'fullscreen' && 'full-image-banner--fullscreen',
      liquid.mediaOptions === 'image' &&
        `full-image-banner--image-overlay-${liquid.overlayOptions}`,
      liquid.mediaOptions === 'video' &&
        `full-image-banner--video-overlay-${liquid.overlayOptions}`,
      `full-image-banner--horizontal-alignment-${liquid.horizontalAlignmentOptions}`,
      `full-image-banner--vertical-alignment-${liquid.verticalAlignmentOptions}`,
      liquid.horizontalAlignmentOptions === 'center' && 'text-center',
    ]"
  >
    <div class="full-image-banner__container">
      <div class="full-image-banner__media-container">
        <video-player
          v-if="
            liquid.mediaOptions == 'video' &&
              (liquid.mobileVideo || liquid.desktopVideoVideo)
          "
          class="full-image-banner__video-player"
          :image="
            isMobile ? liquid.mobileVideo.preview_image :
            liquid.desktopVideo.preview_image
          "
          :video="videoSource"
          :intersection-observer="{
            enable: true,
          }"
          :lazyload="liquid.lazyload"
          is-active
        />

        <div v-html="liquid.mediaImage" />
      </div>

      <div class="full-image-banner__content-container">
        <div v-html="liquid.content" />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Full image banner (full-image-banner)
 * -----------------------------------------------------------------------------
 * Full image banner.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} liquid.layout - layout, either `standard` or `fullscreen`.
 * @param {Boolean} liquid.overlayOptions - Add overlay, either `none`,
 * `fullscreen` or `third`.
 * @param {String} liquid.mediaOptions - Media options, either `image`, `video`.
 * @param {String} liquid.horizontalAlignmentOptions - Content horizontal
 * alignment options, either `left`, `center`, right`.
 * @param {String} liquid.verticalAlignmentOptions - Content vertical
 * alignment options, either `center`, `bottom`.
 * @param {String} liquid.mediaImage - HTML image markup.
 * @param {object} liquid.mobileVideo - Section's Liquid ID.
 * @param {object} liquid.desktopVideo - Section's Liquid ID.
 * @param {String} liquid.content - HTML content markup.
 *
 */
import { mapState } from 'vuex'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'FullImageBanner',

  components: {
    VideoPlayer,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        layout: '',
        overlayOptions: '',
        mediaOptions: '',
        horizontalAlignmentOptions: '',
        verticalAlignmentOptions: '',
        mediaImage: '',
        mobileVideo: {
          type: Object,
          default: () => ({}),
        },
        desktopVideo: {
          type: Object,
          default: () => ({}),
        },
        content: '',
        lazyload: false,
      }),
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Returns the best video src from the supplied video (based on breakpoint).
     */
    videoSource() {
      return this.isMobile
        ? this.getMp4Source(this.liquid.mobileVideo)?.[0]
        : this.getMp4Source(this.liquid.desktopVideo)?.[0]
    },
  },

  mounted() {
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment","1004112136"]);
  },

  methods: {

    /**
     * Returns the highest resolution mp4 video source from the supplied video.
     * @param {Object} video - Shopify video object.
     * @returns {Array}
     */
    getMp4Source(video) {
      const sources = [...video.sources.filter(source => source.format === 'mp4')]
      return sources.sort((a, b) => b.width - a.width)
    },
  },
}
</script>

<style lang="scss">
@import './full-image-banner';
</style>
